/**
 * @fileoverview Animals theme - match animal emojis.
 */

import { ThemeOptions } from '../../../../services/ThemeService.js';
import { EmojiMatchingTheme } from '../../../abstract/EmojiMatchingTheme.js';
import { allLabels } from '../../../Labels.js';

export class BirdsTheme extends EmojiMatchingTheme {
    constructor(options: ThemeOptions = {}) {
        super(
            'birds',
            'Birds',
            allLabels.birds,
            { numPairs: 6, ...options }
        );
    }
}
